import { SVGProps } from 'react';

/**
 * Single-person outline. The stroked counterpart to `AvatarIcon`, whose solid 40×40 glyph
 * reads far heavier than the outline icons it sits beside in a nav list.
 */
export const PersonOutlineIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    data-icon
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.75}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
    {...props}
  >
    <circle cx="12" cy="8" r="4" />
    <path d="M4.5 20.5a7.5 7.5 0 0 1 15 0" />
  </svg>
);
